import React, { useCallback, useMemo, useRef, useState } from 'react';

import { Card, CardActionArea, CardContent, LinearProgress, Typography, } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { savePagePhotos, setObjectPage, uploadPhoto, } from '../../../globalState/object/actions';
import { updateSavingStatus } from "../../../globalState/app/actions";


const PhotoAdd = ({
  objectId,
  section,
  maxCount,
  currentCount,
  setErrorList,
}) => {

  const dispatch = useDispatch();
  const photoInputRef = useRef(null);
  const [totalUploadPhoto, setTotalUploadPhoto] = useState();
  const [uploadedCountPhoto, setUploadedCount] = useState(0);

  /**
   * Перенаправление клика
   */
  const addClick = useCallback((e) => {
    e.preventDefault();
    photoInputRef.current && photoInputRef.current.click();
  }, [photoInputRef]);

  const progress = useMemo(() => {
    return (uploadedCountPhoto / totalUploadPhoto) * 100
  }, [uploadedCountPhoto, totalUploadPhoto])

  const sendPhoto = useCallback(async (photos) => {
    if (!photos.length) return;

    for (let index = 0; index < photos.length; index++) {
      const loadPhoto = new Promise(((resolve) => {
        const formData = new FormData();
        formData.append(`object`, objectId);
        formData.append(`section`, section);
        formData.append(`photos[new-${index + 1}]`, photos[index], photos[index].name);
        formData.append(
          `data`,
          JSON.stringify({
            operationType: 'upload',
          })
        );
        dispatch(uploadPhoto(formData, section))
          .then((response) => {
            /**
             * Обновление ошибок
             */
            if (response.data.photo.errors) {
              const error = {
                message: response.data.photo.errors,
                photoNumber: `"${photos[index].name}"`,
              };
              setErrorList(error);
            }
            setUploadedCount((prev) => prev + 1);
            resolve(index)
          }).catch(() => {
          /**
           * Ошибка серевера
           */
          setUploadedCount((prev) => prev + 1);
          const error = {
            message: `Непредвиденная ошибка`,
            photoNumber: `"${photos[index].name}"`,
          };
          setErrorList(error);
          resolve(index)
        })
      }))

      await loadPhoto;
    }

    /**
     * После сохранения всех фот
     */
    setTotalUploadPhoto(null);
    setUploadedCount(0);

    const formData = new FormData();
    formData.append(`object`, objectId);
    formData.append(`section`, section);
    formData.append(
      `data`,
      JSON.stringify({
        operationType: 'save',
      })
    );
    dispatch(updateSavingStatus({ status: 'success' }));
    dispatch(setObjectPage(section, []));
    dispatch(savePagePhotos(formData, 'photo'));

  }, [dispatch, objectId, section, setErrorList]);

  const onChange = (event) => {
    const files = [...event.target.files];
    setErrorList();
    setTotalUploadPhoto(files.length)
    sendPhoto(files);
  };

  return (
    <div key={'add photo'} className={'col'} style={{ marginBottom: '1rem' }}>
      <input
        id='file'
        multiple
        name='file'
        accept='image/jpeg,image/png,image/jpg,image/tiff'
        type='file'
        ref={photoInputRef}
        onChange={onChange}
        className='d-none'
      />
      <Card
        onClick={addClick}
        className='card add-card card-object-photo h-100'
      >
        <CardActionArea className='d-flex w-100 h-100'>
          {!totalUploadPhoto ? (
            <>
              <CardContent className='add-object__icon'>
                <FontAwesomeIcon icon={'plus'}/>
              </CardContent>
              <CardContent>
                <Typography
                  className='add-object__text text-center'
                  variant='h6'
                >
                  Добавить фотографии
                </Typography>
              </CardContent>
            </>
          ) : (
            <CardContent>
              <LinearProgress
                variant='determinate'
                value={progress}
                className={'card-object-photo__progress-bar'}
              />
              <Typography
                className='add-object__text text-center'
                variant='h6'
              >
                {`Обработано ${uploadedCountPhoto} фото из ${totalUploadPhoto}`}
              </Typography>
            </CardContent>
          )}
        </CardActionArea>
      </Card>
    </div>
  );
};

export default PhotoAdd;
